import { render, staticRenderFns } from "./Comparison-bmw.vue?vue&type=template&id=879e4182&scoped=true&"
import script from "./Comparison-bmw.vue?vue&type=script&lang=js&"
export * from "./Comparison-bmw.vue?vue&type=script&lang=js&"
import style0 from "./Comparison-bmw.vue?vue&type=style&index=0&id=879e4182&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879e4182",
  null
  
)

export default component.exports